import React from "react";
// import TrackDetailBtn from "../../TrainingModuleDetail-Components/TrackDetailComponent/TrackDetailBtn";
import { backendTrack } from "./track.dto"; 
import { Link } from "react-router-dom";

function Track2Card() {
  return (
    <div>
      <div className=" m-3 rounded p-3 track">
          <h4 className="align-left">Track 2 - <span className="track-name">Web Development</span></h4>
          <hr className="hr" />
      {backendTrack.map((track2, index) => (
        <div className="row track-card pt-3 w-70" key={index}>
          <div className="col-4">
            <img
              src={track2.image} 
              className="p-0 img-fluid m-0 rounded-start track-img"
              alt=""
            />
          </div>
          <div className="col-6">
            <h5 className="card-title fw-bold">{track2.title}</h5>
            <p className="card-text fw-light mt-2">{track2.description}</p> 
            {/* <TrackDetailBtn /> */}
            {/* <a href="/track2Detail" className="btn track-btn align-self-start">
              Detail
            </a> */}
            <Link
                to={`/track2Detail/${track2.id}`}
                className="btn track-btn align-self-start"
              >
                Detail
              </Link>
          </div>
        </div>
      ))}
    </div>
    </div>

  );
}

export default Track2Card;
